import styled, {
  css,
  DefaultTheme,
  ThemedStyledProps
} from 'styled-components';

import { errorCircle, warningCircle, info, check } from '~/App/helpers/icons';
import { ContainerProps } from './types';

const errorStyle = css<ContainerProps>`
  background-color: ${({ theme }) => theme.colors.errorRedMedium};

  &&::before {
    ${warningCircle}
    color: ${({ theme }) => theme.colors.errorRedDark};
  }
`;

const infoStyle = css<ContainerProps>`
  background-color: ${({ theme }) => `${theme.colors.iceberg}`};

  &&::before {
    ${info}
    color: ${({ theme }) => theme.colors.deepSeaGreen};
  }
`;

const warningStyle = css<ContainerProps>`
  background-color: ${({ theme }) => theme.colors.blanchedAlmond};

  &&::before {
    ${errorCircle}
    color: ${({ theme }) => theme.colors.gambogeOrange};
  }
`;

const successStyle = css<ContainerProps>`
  background-color: ${({ theme }) => theme.colors.skeptic};

  &&::before {
    ${check}
    color: ${({ theme }) => theme.colors.crusoe};
  }
`;

function getTypeStyle(props: ThemedStyledProps<ContainerProps, DefaultTheme>) {
  const { type } = props;

  switch (type) {
    case 'error':
      return errorStyle;
    case 'warning':
      return warningStyle;
    case 'info':
      return infoStyle;
    case 'success':
    default:
      return successStyle;
  }
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: row;
  padding: 1.5rem 1.5rem 2rem;
  gap: 1.125rem;
  border-radius: 0.25rem;

  &&::before {
    font-size: 1.5rem;
    line-height: inherit !important;
  }

  ${getTypeStyle}
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  justify-content: center;
`;

export const Title = styled.p`
  font-size: 1.375rem;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
`;
export const Message = styled.p`
  font-size: 1.125rem;
`;
